module.exports = __webpack_public_path__ + "img/Disc brake pad.ebf8b4b4.png";